import React from 'react'
import Hero from '../components/Hero/hero';

const Home = () => {
  return (
    <div>
        <Hero />
    </div>
  )
}

export default Home;